/* ==========================================================================
   SIDUS - desktop auto-scroll for the home page carousels
   Real desktops only (1025px+ with a mouse/trackpad that can hover): New
   Launch, Watch & Buy and Testimonials glide continuously and loop seamlessly.
   Hovering, focusing, touching or scrolling one by hand pauses it.

   Tablets (iPad) and phones: nothing runs. The rows stay native finger-swipe
   carousels - no cloned slides, no per-frame scrolling. On iPad the glide used
   to clone every card (memory pressure -> Safari reloading the page) and keep
   writing scrollLeft while the visitor swiped (blank / black flashes, lag).
   Visitors with "reduce motion" switched on also keep the manual rows.
   ========================================================================== */
(function () {
  'use strict';

  // scroller selector -> element whose children are the slides
  var TARGETS = [
    { scroller: '.sd-autoslider', list: '.sd-autoslider__track' },
    { scroller: '.sd-watch__grid', list: null },
    { scroller: '.sd-testimonials__scroller', list: '.sd-testimonials__grid' }
  ];
  var SPEED = 40;          // px per second
  var RESUME_DELAY = 1500; // ms after a manual scroll before gliding again

  // A primary pointer that can hover and is precise = mouse/trackpad desktop.
  // iPads (even 1180px landscape) report a coarse, non-hover primary pointer.
  var desktop = window.matchMedia('(min-width: 1025px) and (hover: hover) and (pointer: fine)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var sliders = [];

  function Slider(scroller, list) {
    this.el = scroller;
    this.list = list || scroller;
    this.items = Array.prototype.slice.call(this.list.children);
    this.clones = [];
    this.active = false;
    this.paused = false;
    this.pos = 0;
    this.loop = 0;
    this.last = 0;
    this.raf = 0;
    this.resumeTimer = 0;
    this.bind();
  }

  Slider.prototype.bind = function () {
    var self = this;
    var pause = function () { self.paused = true; };
    var resume = function () {
      if (self.el.matches(':hover') || self.el.contains(document.activeElement)) return;
      self.paused = false;
    };
    this.el.addEventListener('mouseenter', pause);
    this.el.addEventListener('mouseleave', resume);
    this.el.addEventListener('focusin', pause);
    this.el.addEventListener('focusout', function () { setTimeout(resume, 0); });
    // manual trackpad / wheel / scrollbar / touch movement takes over for a moment
    var manual = function () {
      if (!self.active) return;
      self.paused = true;
      clearTimeout(self.resumeTimer);
      self.resumeTimer = setTimeout(function () {
        self.pos = self.el.scrollLeft;
        resume();
      }, RESUME_DELAY);
    };
    this.el.addEventListener('wheel', manual, { passive: true });
    this.el.addEventListener('pointerdown', manual);
    this.el.addEventListener('touchstart', manual, { passive: true });
    this.el.addEventListener('touchmove', manual, { passive: true });
    this.el.addEventListener('scroll', function () {
      if (!self.active) return;
      // someone other than us moved it (scrollbar drag, keyboard) - follow it
      if (Math.abs(self.el.scrollLeft - Math.round(self.pos)) > 2 && !self.settingScroll) {
        self.pos = self.el.scrollLeft;
      }
    }, { passive: true });
  };

  Slider.prototype.measure = function () {
    if (!this.clones.length) return 0;
    return this.clones[0].offsetLeft - this.items[0].offsetLeft;
  };

  Slider.prototype.start = function () {
    if (this.active || this.items.length < 2) return;
    var self = this;

    // Append copies of the slides until there is at least one extra screen
    // of content, so the row can wrap around without a visible jump.
    var guard = 0;
    do {
      this.items.forEach(function (item) {
        var c = item.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('data-sd-clone', '');
        c.removeAttribute('id');
        c.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (n) {
          n.setAttribute('tabindex', '-1');
        });
        c.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
        self.list.appendChild(c);
        self.clones.push(c);
      });
      guard++;
    } while (this.list.scrollWidth - this.measure() < this.el.clientWidth * 2 && guard < 6);

    this.loop = this.measure();
    if (this.loop <= 0) { this.stop(); return; }

    this.el.classList.add('sd-is-autoscrolling');
    this.pos = this.el.scrollLeft % this.loop;
    this.active = true;
    this.last = performance.now();
    this.raf = requestAnimationFrame(function tick(now) {
      if (!self.active) return;
      var dt = Math.min(now - self.last, 64) / 1000;
      self.last = now;
      if (!self.paused && !document.hidden) {
        self.pos += SPEED * dt;
        if (self.pos >= self.loop) self.pos -= self.loop;
        self.settingScroll = true;
        self.el.scrollLeft = self.pos;
        self.settingScroll = false;
      } else if (self.pos >= self.loop) {
        self.pos -= self.loop;
        self.el.scrollLeft = self.pos;
      }
      self.raf = requestAnimationFrame(tick);
    });
  };

  Slider.prototype.stop = function () {
    this.active = false;
    cancelAnimationFrame(this.raf);
    clearTimeout(this.resumeTimer);
    this.clones.forEach(function (c) { c.remove(); });
    this.clones = [];
    this.el.classList.remove('sd-is-autoscrolling');
    this.el.scrollLeft = 0;
    this.pos = 0;
  };

  function sync() {
    var on = desktop.matches && !reduced.matches;
    sliders.forEach(function (s) { on ? s.start() : s.stop(); });
  }

  function init() {
    TARGETS.forEach(function (t) {
      document.querySelectorAll(t.scroller).forEach(function (el) {
        if (el.__sdAuto) return;
        var list = t.list ? el.querySelector(t.list) : el;
        if (!list) return;
        el.__sdAuto = new Slider(el, list);
        sliders.push(el.__sdAuto);
      });
    });
    sync();
  }

  function onChange() { sync(); }
  if (desktop.addEventListener) {
    desktop.addEventListener('change', onChange);
    reduced.addEventListener('change', onChange);
  } else {
    desktop.addListener(onChange);
    reduced.addListener(onChange);
  }

  // re-measure once images have laid out, and after a resize settles
  window.addEventListener('load', function () {
    sliders.forEach(function (s) { if (s.active) { s.loop = s.measure(); } });
  });
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      sliders.forEach(function (s) { if (s.active) { s.loop = s.measure(); if (s.pos >= s.loop) s.pos %= s.loop; } });
    }, 200);
  });

  // theme editor: rebuild when a section is re-rendered
  document.addEventListener('shopify:section:load', function () {
    sliders.forEach(function (s) { s.stop(); });
    sliders = [];
    init();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
